import { routes } from '@redwoodjs/router'

import {
  useIsGov,
  useIsGovWellStaff,
  useMyRecordTypes,
  useMyUser,
} from '../layouts/AppStateContextLayout/utils'

export const useHomePage = () => {
  const isGov = useIsGov()
  const isGovWellStaff = useIsGovWellStaff()
  const recordTypes = useMyRecordTypes()
  const me = useMyUser()

  if (isGovWellStaff) {
    return routes.adminOrgs()
  }
  if (isGov) {
    if (recordTypes?.length) {
      if (me?.group === 'Reviewer') {
        return routes.tasks()
      }

      // This used to redirect to the records list, but we're using insights as the home page for gov users
      return routes.insights()
    }
    return routes.settings()
  } else {
    return routes.citizenRecords()
  }
}
